//libs
import React, { memo } from 'react';

//components
import { useStoreIcon, IconName } from 'shared/icons';

//hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

import { ViewSimilarButton } from './styles';

const ARIA_LABELS = {
  VIEW_SIMILAR_PRODUCTS: 'View similar products',
};

interface ViewSimilar {
  className: string;
  onClick: (event: MouseEvent) => void;
}

const ViewSimilar = ({ className = '', onClick }: ViewSimilar) => {
  const SimilarItems = useStoreIcon(IconName.SIMILAR_ITEMS);
  const keyboardProps = useKeyboardClick(onClick);

  return (
    <ViewSimilarButton
      {...keyboardProps}
      className={`circle ${className}`}
      aria-label={ARIA_LABELS.VIEW_SIMILAR_PRODUCTS}
      type="button"
    >
      <SimilarItems aria-hidden="true" />
    </ViewSimilarButton>
  );
};

export default memo(ViewSimilar);
